import { useState } from "react";

const faqs = [
  {
    question: "Comment se passe une intervention à Obernai ?",
    answer:
      "Obernai se trouve à une demi-heure de notre atelier. Pour une urgence, nous intervenons en 24 heures. Pour une réparation programmée, comptez 24 à 48 heures. Le technicien arrive avec son stock de pièces, diagnostique gratuitement et vous remet un devis détaillé. Vous ne payez qu'après acceptation, et seulement si la réparation est réussie.",
  },
  {
    question: "Le déplacement est-il compris dans le prix ?",
    answer:
      "Oui, le déplacement est totalement gratuit. Il n'y a pas de frais cachés, pas de surprise. Le devis que nous vous remettons précise le coût de la pièce, la main-d'œuvre et le prix total. Vous acceptez ou refusez, sans engagement. Le déplacement et le diagnostic sont offerts dans tout le Bas-Rhin, Obernai y compris.",
  },
  {
    question: "Vos techniciens connaissent-ils les fenêtres alsaciennes anciennes ?",
    answer:
      "Oui, et c'est une de nos forces. Obernai regorge de maisons à colombages avec des fenêtres en bois traditionnelles. Nos techniciens sont formés aux spécificités de ces menuiseries et disposent des pièces adaptées. Nous réparons aussi les fenêtres modernes des constructions récentes : PVC, aluminium, toutes marques. Chaque pièce remplacée est garantie 10 ans.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-8 md:mb-10">
            Questions fréquentes — Obernai
          </h2>
          <div className="space-y-3 md:space-y-4">
            {faqs.map((faq, i) => {
              const isOpen = openIndex === i;
              return (
                <div
                  key={i}
                  className="bg-rose-50 rounded-2xl border border-rose-100 overflow-hidden"
                >
                  <button
                    onClick={() => setOpenIndex(isOpen ? null : i)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left"
                  >
                    <span className="font-semibold text-base md:text-lg text-plum-dark">
                      {faq.question}
                    </span>
                    <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center shrink-0">
                      <i className={`ri-${isOpen ? "subtract" : "add"}-line text-plum`} />
                    </div>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 md:px-6 md:pb-6">
                      <p className="text-sm md:text-base text-plum-dark/80 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}